import { BlankSlate, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface EmptyEmployeesProps {
  openEmployeeModal: () => void
}
const EmptyEmployees = ({ openEmployeeModal }: EmptyEmployeesProps) => {
  return (
    <BlankSlate
      title={i18n.t('budgets.detail.tabs.employees.blank_slate.title')}
      description={i18n.t('budgets.detail.tabs.employees.blank_slate.description')}
      illustration="add-user"
    >
      <Button.Decorative onPointerDown={openEmployeeModal} iconName="add">
        {i18n.t('budgets.detail.add_employee')}
      </Button.Decorative>
    </BlankSlate>
  )
}

export default EmptyEmployees
